import { render, staticRenderFns } from "./FormFiguresInputFile.vue?vue&type=template&id=45db3f4f"
import script from "./FormFiguresInputFile.vue?vue&type=script&lang=ts"
export * from "./FormFiguresInputFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports